module.exports = __webpack_public_path__ + "img/footer-imposters-logo.1e70c496.svg";